import React, { useContext, useEffect, useMemo, useState } from "react";
import styles from './PermissionModal.module.css';
import useTheme from "config/useTheme";
import ModalContext from "config/context/modalContext";
import SelectModalOption from "./SelectModalOption";
import ModalShell from "components/shared/modal/ModalShell";
import { useSetPermission } from "api/permissions/usePermissions";
import Loader from "components/shared/loader/Loader";
import SuccessfullActionModal from "./SuccessfullActionModal";
import { useCompositionsContext } from 'features/compositions/context/CompositionsContext';

const SetPermissionModal = ({ permissionName, finalStepDuration, permissionParentName }) => {
  const { dark } = useTheme();
  const { compositionNames, databaseStructure } = useCompositionsContext();
  const [selectedComposition, setSelectedComposition] = useState("");
  const { handleModal } = useContext(ModalContext);
  const [isValid, setIsValid] = useState(false);
  const [data, setData] = useState({
    permission_name: permissionName,
    permission_parent_private_key: "",
    composition: selectedComposition,
  });

  const selectedName = useMemo(() => {
    return (
      databaseStructure?.compositions?.find((c) => c.name === selectedComposition)?.name || ""
    );
  }, [databaseStructure, selectedComposition]);

  const { response, loading, error, setPermission, resetServerStatus } =
    useSetPermission({
      permissionName: data?.permission_name,
      permissionParentPrivateKey: data?.permission_parent_private_key,
      composition: selectedName,
    });

  const compositions = useMemo(() => compositionNames || [], [compositionNames]);

  useEffect(() => {
    setData((prevData) => ({
      ...prevData,
      composition: selectedComposition,
    }));
  }, [selectedComposition]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (
      !data?.permission_name ||
      !data?.permission_parent_private_key ||
      !data?.composition
    ) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  }, [data]);

  useEffect(() => {
    if (response?.status && !error) {
      setTimeout(() => {
        resetServerStatus();
        handleModal(false);
        window.location.reload();
      }, finalStepDuration || 1600);
    }
  }, [response, error]);

  const handleSetPermission = (event) => {
    event.preventDefault();
    setPermission();
  };

  if (loading) {
    return (
      <ModalShell>
        <Loader />
      </ModalShell>
    );
  }

  if (response?.status) {
    return (
      <ModalShell>
        <SuccessfullActionModal message={response?.message} />
      </ModalShell>
    );
  }

  return (
    <ModalShell closeOnOverlay={true}>
      <div className={`${styles.component} ${dark ? styles.dark : ""}`}>
        <div className={styles.label}>Set permission</div>
        <form id="set_permission_form" onSubmit={handleSetPermission}>
          <SelectModalOption
            placeholder={
              selectedComposition ? selectedComposition : "Select composition"
            }
            setOption={setSelectedComposition}
            optionList={compositions}
          />

          <div className={styles.input_group}>
            {/* <p>"{permissionParentName}" permission private key</p> */}
            <p>"active" permission private key</p>
            <div className={styles.input_block}>
              <input
                type="text"
                placeholder="Private key"
                name="permission_parent_private_key"
                value={data.permission_parent_private_key}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </form>
        {error && (
          <div className={styles.form_msg}>
            <span>{error}</span>
          </div>
        )}
        <div className={styles.form_actions}>
          <button type="submit" form="set_permission_form" disabled={!isValid}>
            Set
          </button>
          <button onClick={() => handleModal(false)}>Cancel</button>
        </div>
      </div>
    </ModalShell>
  );
};

export default SetPermissionModal;
